import React from 'react';
import { connect } from 'react-redux';
import LeftMenuV2 from './left-menu-v2';
import { dispatchMenuState } from './left-menu-actions';

const mapStateToProps = (state, ownProps) => {
    const { menuID } = ownProps;
    return {
        compareProducts: state.compare.products,
        compareModalOpen: state.compare.modal,
        isDragging: state.compare.isDragging,
        customFields: ownProps.customFields || state.slugInfo.components.leftMenu,
        leftMenuActive: menuID ? state.leftMenu.activeID[menuID] : state.leftMenu.active,
        activeID: state.leftMenu.activeID,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        dispatchMenuState: (value, menuID) => dispatch(dispatchMenuState(value, menuID)),
    };
};

class ToggleLeftMenuWrapper extends React.PureComponent {
    constructor(props) {
        super(props);
        this.setMenuState(props);
        this.toggleMenuState = this.toggleMenuState.bind(this);
    }

    componentDidUpdate(prevProps) {
        const { defaultExpanded } = this.props;
        if (prevProps.defaultExpanded !== defaultExpanded && defaultExpanded) {
            this.setMenuState(this.props);
        }
    }

    setMenuState(props) {
        const { defaultExpanded, activeID, menuID, dispatchMenuState, leftMenuActive } = props || {};
        if (defaultExpanded && !leftMenuActive && (!menuID || !(menuID in activeID))) {
            dispatchMenuState && dispatchMenuState(true, menuID);
        }
    }

    toggleMenuState(menuActive) {
        const { menuID, dispatchMenuState } = this.props;
        dispatchMenuState && dispatchMenuState(menuActive, menuID);
    }

    render() {
        const { leftMenuActive, children } = this.props;
        return children ? children({ dispatchMenuState: this.toggleMenuState, leftMenuActive }) : null;
    }
}

export const ToggleLeftMenu = connect(mapStateToProps, mapDispatchToProps)(ToggleLeftMenuWrapper);

export default connect(mapStateToProps, mapDispatchToProps)(LeftMenuV2);
